import { useSignal } from "@preact/signals-react";
import { useSubscribable } from "./useSubscribable";
export function useEventsource(eventsource) {
  var state = useSignal(eventsource.state);
  useSubscribable(eventsource, function (value) {
    state.value = value;
  });
  return state;
}